import { render, staticRenderFns } from "./OrgHomeMarketing.vue?vue&type=template&id=104e9b70&scoped=true&"
import script from "./OrgHomeMarketing.vue?vue&type=script&lang=js&"
export * from "./OrgHomeMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104e9b70",
  null
  
)

export default component.exports